import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { KEY_TAB, TEXTAREA_TEXTINPUTDIV_ID } from '@/constants';
import { usePopupOpen } from '@/hooks';
import {
  switchNextSectionByShieldThunk,
  setFloatableInputVisible,
  setRemoveBlurFromAllInputs,
} from '@/actions';
import { getElementByGetElementById } from '@/helpers';

export default () => {
  const floatableInputVisible = useSelector(
    state => state.core.floatableInputVisible
  );
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();
  const isEditModeEnabled = floatableInputVisible;

  useEffect(() => {
    if (isSomePopupOpen) {
      removeListener();
    } else {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      removeListener();
    };
  });

  const removeListener = () => {
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleKeyDown = event => {
    if (event.code === KEY_TAB) {
      event.preventDefault();
      dispatch(setRemoveBlurFromAllInputs(true));

      if (isEditModeEnabled) {
        getElementByGetElementById(TEXTAREA_TEXTINPUTDIV_ID)?.blur();
        dispatch(setFloatableInputVisible(false));
      }
      dispatch(switchNextSectionByShieldThunk());
    }
  };
};
